import type { I18n, VueI18n } from 'vue-i18n'
import { createI18n } from 'vue-i18n'
import messages from '@intlify/unplugin-vue-i18n/messages'
import type en from '~~/locales/en.json'

let globalI18n: any

type MessageSchema = typeof en

export const createI18nPlugin = async (): Promise<
  I18n<{}, {}, {}, string, true>
> => {
  const i18n = await createI18n<[MessageSchema], 'en' | 'fr'>({
    locale: 'en',
    fallbackLocale: 'en',
    legacy: false,
    globalInjection: true,
    messages,
  })

  return i18n
}

export const getI18n = () => globalI18n

export default defineNuxtPlugin(async (nuxtApp) => {
  globalI18n = await createI18nPlugin()

  nuxtApp.vueApp.config.globalProperties.$i18n = globalI18n as VueI18n

  // @ts-expect-error infer type
  nuxtApp.vueApp.i18n = globalI18n

  nuxtApp.vueApp.use(globalI18n)
})
